import { action } from 'satcheljs';

// Specify an optional onOptionsLoaded callback to be notified when the options finish loading. This
// is useful for any consumers who can't observe the mobx store
export const loadOptions = action('loadOptions', (onOptionsLoaded?: () => void) => ({
    onOptionsLoaded: onOptionsLoaded,
}));
